var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "px-2 pt-2", attrs: { flat: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "d-inline-flex" },
            [
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("ReadonlyField", {
                    attrs: {
                      label: _vm.$t("label.departure"),
                      value: _vm.departureLabel,
                      icon: "mdi-map-marker-outline",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("ReadonlyField", {
                    attrs: {
                      label: _vm.$t("label.arrival"),
                      value: _vm.arrivalLabel,
                      icon: "mdi-map-marker-outline",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("ReadonlyField", {
                    attrs: {
                      label: _vm.$t("label.company"),
                      value: _vm.timetable.sender?.name,
                      icon: "mdi-account-arrow-right",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("ReadonlyField", {
                    attrs: {
                      label: _vm.$t("label.booking"),
                      value: _vm.timetable.messageId,
                      icon: "mdi-file",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-2" },
        [
          _c(
            "v-col",
            { staticClass: "d-inline-flex" },
            [
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("ReadonlyField", {
                    attrs: {
                      label: _vm.$t("label.statusDateTime"),
                      value: _vm.formatDateShort(_vm.timetable.statusDateTime),
                      icon: "mdi-calendar",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("ReadonlyField", {
                    attrs: {
                      label: _vm.$t("label.closingOfBooking"),
                      value: _vm.formatDateShort(
                        _vm.timetable.closingOfBooking
                      ),
                      icon: "mdi-calendar-lock",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("ReadonlyField", {
                    attrs: {
                      label: _vm.$t("label.closingOfAcceptance"),
                      value: _vm.formatDateShort(
                        _vm.timetable.closingOfAcceptance
                      ),
                      icon: "mdi-calendar-check",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("ReadonlyField", {
                    attrs: {
                      label: _vm.$t("label.closingOfLoading"),
                      value: _vm.formatDateShort(
                        _vm.timetable.closingOfLoading
                      ),
                      icon: "mdi-calendar-arrow-right",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-2" },
        [
          _c(
            "v-col",
            { staticClass: "d-inline-flex" },
            [
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("ReadonlyField", {
                    attrs: {
                      label: _vm.$t("label.trainNumber"),
                      value: _vm.timetable.trainNumber,
                      icon: "mdi-train",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("ReadonlyField", {
                    attrs: {
                      label: _vm.$t("label.trainStatus"),
                      value: _vm.timetable.trainStatus,
                      icon: "mdi-train",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("ReadonlyField", {
                    attrs: {
                      label: _vm.$t("label.trainType"),
                      value: _vm.timetable.trainType,
                      icon: "mdi-train",
                    },
                  }),
                ],
                1
              ),
              _c("v-col", { staticClass: "pa-0" }),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-divider", { staticClass: "mt-2 mb-0" }),
      _c(
        "v-data-table",
        {
          staticClass: "pa-0",
          attrs: {
            headers: _vm.transitHeaders,
            items: _vm.timetable.transitEntryList || [],
            "items-per-page": 1000,
            "hide-default-footer": "",
            dense: "",
          },
          scopedSlots: _vm._u([
            {
              key: "item.eventDateTime",
              fn: function ({ item }) {
                return [
                  _vm._v(
                    " " + _vm._s(_vm.formatDateShort(item.eventDateTime)) + " "
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "no-data" },
            [
              _c(
                "v-icon",
                {
                  staticClass: "mr-1",
                  attrs: { color: "warning", size: "20" },
                },
                [_vm._v("mdi-alert")]
              ),
              _c("span", { staticClass: "font-weight-medium warning--text" }, [
                _vm._v(" " + _vm._s(_vm.$t("label.noTrackingInfo")) + " "),
              ]),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }